export const PC_BREAKPOINT = 768

export const PAYED_TEAM_MIGRATE_NOT_ALLOWED =
  "エラーコード023\n「らくらく連絡網＋」は有料版の機能を搭載していないため、現状移行できません。"

export const TIME_INTERVAL_REPLY_THREAD = 30000
